
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/moneybackguarantee",
      function () {
        return require("private-next-pages/company/moneybackguarantee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/moneybackguarantee"])
      });
    }
  